import { render, staticRenderFns } from "./adminOtpPopup.vue?vue&type=template&id=77c6e331&scoped=true&"
import script from "./adminOtpPopup.vue?vue&type=script&lang=js&"
export * from "./adminOtpPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c6e331",
  null
  
)

export default component.exports